import React from 'react'
import { WithTemplate } from '@morningtrain/react-app'
import { Form, Model } from '@morningtrain/react-resources'
import { Link } from '@morningtrain/react-navigation'
import * as Fields from 'support/fields'
import { Fieldset } from 'layouts'
import { Env } from '@morningtrain/helpers'
import LoginPipeline from 'support/pipelines/LoginPipeline'
import { Translation } from '@morningtrain/react-translations'

export default class AdminLogin extends React.Component {
  render () {
    return (
      <WithTemplate template='Auth'>
        <Form route='auth.login.login'>
          <LoginPipeline />

          <div className='form-content login'>
            <Fieldset cols={1}>
              <Fields.Input
                name='email'
                label={<Translation name='fields.email.label' />}
                required
                autoFocus
              />
              <Fields.Password
                name='password'
                label={<Translation name='fields.password.label' />}
                required
              />
            </Fieldset>
          </div>

          <div className='mt-6 flex items-center justify-between'>
            <div className='flex items-center'>
              <Fields.Checkbox
                name='remember'
                label={<Translation name='auth.actions.remember_me' />}
                className='checkbox-field flex flex-row-reverse space-x-2'
                boxed
              />
            </div>

            <div className='text-sm leading-5'>
              <Link
                className='font-medium text-primary-500 hover:text-primary-500 focus:outline-none focus:underline transition ease-in-out duration-150'
                route={[Env.get('page.namespace'), 'auth.forgot-password'].join('.')}
              >
                <Translation name='auth.actions.forgot_password' />
              </Link>
            </div>
          </div>

          <div className='mt-6'>
            <span className='block w-full rounded-md shadow-sm'>
              <button
                type='submit'
                className='w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-primary-500 hover:bg-primary-400 focus:outline-none focus:border-primary-700 focus:shadow-outline-primary active:bg-primary-700 transition duration-150 ease-in-out'
              >
                <Translation name='auth.actions.login' />
              </button>
            </span>
          </div>
        </Form>
      </WithTemplate>
    )
  }
}
